import {
  ApartmentOutlined,
  AssessmentOutlined,
  BlockOutlined,
  DescriptionOutlined,
  FilterAltOutlined,
  PeopleAltOutlined,
  PersonOutline,
  PlaylistRemoveOutlined,
  ReportOutlined,
  SupervisedUserCircleOutlined,
} from '@mui/icons-material';
import { IMenu } from '@dfl/mui-react-common';
import { REPORT_CAUSE_PERMISSIONS } from 'modules/crm/settings/report-cause/constants';
import { DISALLOWED_WORD_PERMISSIONS } from 'modules/crm/settings/disallowed-word/constants';
import { ClientIcon, ReviewIcon } from 'modules/crm/common/components/icons';
import { AddressBookIcon } from 'modules/crm/common/components/icons/AddressBookIcon';
import { CLIENTS_PERMISSIONS } from 'modules/crm/clients/constants';
import { SEGMENT_PERMISSIONS } from 'modules/crm/segments/constants/segment.permissions';
import { BUSINESS_ACCOUNT_REQUEST_PERMISSIONS } from 'modules/crm/clients/constants/business-account-request.permissions';
import { ADDRESS_BOOK_PERMISSIONS } from 'modules/crm/address-book/constants';
import { ACCOUNT_DELETION_REASON_PERMISSIONS } from 'modules/crm/settings/account-deletion-reason/constants';
import { REPORTS_PERMISSIONS } from 'modules/dashboard/constant/reports.permissions';
import { REVIEWS_PERMISSIONS } from 'modules/crm/reviews/constants';
import { BLOCK_CAUSE_PERMISSIONS } from 'modules/crm/settings/block-cause/constants';
import {
  disabledReviews,
  disabledClientsWithOrders,
  disabledClientsWithoutOrders,
  disabledAddressBooks,
  disabledReportCauses,
  disabledDisallowedWords,
  disabledAccountDeletionReasons,
  disabledBlockCauses,
  disableCancelledOrdersReport,
  disabledB2B,
} from 'utils/flags-utils';

export const CRM_MENU: IMenu[] = [
  {
    title: 'main_menu.admin.section.clients.title',
    prefix: '/crm',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.clients.clients',
        path: '/crm/clients',
        partialMatch: false,
        permissions: [CLIENTS_PERMISSIONS.CLIENTS_VIEW],
        icon: <ClientIcon fontSize='small' />,
      },
      {
        title: 'main_menu.admin.section.clients.segmentation',
        path: '/crm/clients/segmentation',
        partialMatch: false,
        permissions: [SEGMENT_PERMISSIONS.VIEW],
        icon: <FilterAltOutlined fontSize='small' />,
      },
      ...(!disabledB2B
        ? [
            {
              title: 'main_menu.admin.section.clients.businessAccountRequests',
              path: '/crm/clients/business-requests',
              partialMatch: false,
              permissions: [BUSINESS_ACCOUNT_REQUEST_PERMISSIONS.BUSINESS_ACCOUNT_REQUEST_VIEW],
              icon: <ApartmentOutlined fontSize='small' />,
            },
          ]
        : []),
      ...(!disabledClientsWithOrders
        ? [
            {
              title: 'main_menu.admin.section.clients.withOrders',
              path: '/crm/clients/with-orders',
              partialMatch: false,
              permissions: [CLIENTS_PERMISSIONS.CLIENTS_VIEW],
              icon: <PeopleAltOutlined fontSize='small' />,
            },
          ]
        : []),
      ...(!disabledClientsWithoutOrders
        ? [
            {
              title: 'main_menu.admin.section.clients.withoutOrders',
              path: '/crm/clients/without-orders',
              partialMatch: false,
              permissions: [CLIENTS_PERMISSIONS.CLIENTS_VIEW],
              icon: <PersonOutline fontSize='small' />,
            },
          ]
        : []),
      ...(!disableCancelledOrdersReport
        ? [
            {
              title: 'main_menu.admin.section.clients.cancelledOrders',
              path: '/crm/clients/cancelled-orders',
              partialMatch: false,
              permissions: [REPORTS_PERMISSIONS.REPORT_CANCELLED_ORDERS_READ],
              icon: <SupervisedUserCircleOutlined fontSize='small' />,
            },
          ]
        : []),
      ...(!disabledAddressBooks
        ? [
            {
              title: 'main_menu.admin.section.clients.address-books',
              path: '/crm/address-books',
              partialMatch: true,
              permissions: [ADDRESS_BOOK_PERMISSIONS.ADDRESS_BOOK_VIEW],
              icon: <AddressBookIcon fontSize='small' />,
            },
          ]
        : []),
      ...(!disabledReviews
        ? [
            {
              title: 'main_menu.admin.section.clients.reviews',
              path: '/crm/reviews',
              partialMatch: true,
              icon: <ReviewIcon fontSize='small' />,
              permissions: [REVIEWS_PERMISSIONS.REVIEWS_VIEW],
            },
          ]
        : []),
    ],
  },
  {
    title: 'main_menu.admin.section.general.reports',
    prefix: '/crm/reports',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.clients.clients',
        path: '/crm/reports/clients',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        permissions: [REPORTS_PERMISSIONS.REPORT_CLIENTS],
      },
    ],
  },
  {
    title: 'main_menu.admin.section.general.settings',
    prefix: '/crm/settings',
    atLessOne: true,
    items: [
      ...(!disabledReportCauses
        ? [
            {
              title: 'reportCause:list',
              path: '/crm/settings/report-causes',
              partialMatch: true,
              icon: <ReportOutlined fontSize='small' />,
              permissions: [REPORT_CAUSE_PERMISSIONS.REPORT_CAUSE_VIEW],
            },
          ]
        : []),
      ...(!disabledDisallowedWords
        ? [
            {
              title: 'disallowedWord:list',
              path: '/crm/settings/disallowed-words',
              partialMatch: true,
              icon: <DescriptionOutlined fontSize='small' />,
              permissions: [DISALLOWED_WORD_PERMISSIONS.DISALLOWED_WORD_VIEW],
            },
          ]
        : []),
      ...(!disabledAccountDeletionReasons
        ? [
            {
              title: 'main_menu.admin.section.clients.deletionReasons',
              path: '/crm/settings/account-deletion-reasons',
              partialMatch: true,
              icon: <PlaylistRemoveOutlined fontSize='small' />,
              permissions: [ACCOUNT_DELETION_REASON_PERMISSIONS.ACCOUNT_DELETION_REASON_VIEW],
            },
          ]
        : []),
      ...(!disabledBlockCauses
        ? [
            {
              title: 'blockCause:list',
              path: '/crm/settings/block-causes',
              partialMatch: true,
              icon: <BlockOutlined fontSize='small' />,
              permissions: [BLOCK_CAUSE_PERMISSIONS.BLOCK_CAUSE_VIEW],
            },
          ]
        : []),
    ],
  },
];
